import { ArrowBack, Error, VideoLibrary } from '@mui/icons-material';
import { Box, Button, Chip, Divider, Grid2 as Grid, Paper, Typography } from '@mui/material';
import { VideoGalleryGridItem, VideoGalleryGridItemSkeleton } from '../VideoGalleryGridItem';

import { EmptyState } from '../../../../components/EmptyState';
import React from 'react';
import ReactPlayer from 'react-player';
import { getPageTitle } from '../../helpers';
import { useGetVideos } from '../../hooks/useGetVideos';
import { useStyles } from './styles';
import { useVideoTutorials } from '../../VideoTutorialsContext';

const NUMBER_OF_NEXT_VIDEOS = 4;

const NextVideos = () => {
  const { selectedVideo, setSelectedVideo } = useVideoTutorials();

  const {
    videos: nextVideos,
    loading,
    error,
  } = useGetVideos({
    search: '',
    contextPage: [selectedVideo.contextPage],
    after: selectedVideo.contextOrder,
    page: 0,
    perPage: NUMBER_OF_NEXT_VIDEOS,
    order: 'asc',
    orderBy: 'contextOrder',
  });

  if (error) {
    return (
      <EmptyState
        Icon={Error}
        title="Error"
        description="Failed to load next videos. Please try again later."
      />
    );
  }

  if (!nextVideos?.length && !loading) {
    return <EmptyState Icon={VideoLibrary} description="No next videos to watch" />;
  }

  return (
    <Grid container spacing={1}>
      {loading &&
        Array(NUMBER_OF_NEXT_VIDEOS)
          .fill(0)
          .map((_, i) => <VideoGalleryGridItemSkeleton key={i} />)}
      {!loading &&
        nextVideos?.map((video, index) => (
          <VideoGalleryGridItem key={index} video={video} onClick={setSelectedVideo} />
        ))}
    </Grid>
  );
};

export const VideoPlayer = () => {
  const classes = useStyles();
  const { selectedVideo, setSelectedVideo } = useVideoTutorials();
  const { title, url, description, contextPage, contextOrder } = selectedVideo;

  return (
    <Box sx={{ display: 'flex', gap: '25px', alignItems: 'flex-start' }}>
      <Box sx={{ flex: 80 }}>
        <Box sx={{ marginBottom: '16px' }}>
          <Button
            variant="text"
            color="secondary"
            onClick={() => setSelectedVideo(null)}
            startIcon={<ArrowBack />}
          >
            <Typography
              variant="body1"
              sx={{
                color: 'secondary',
              }}
            >
              Back to gallery
            </Typography>
          </Button>
        </Box>

        <ReactPlayer url={url} controls width="100%" height="100%" />
        <Box sx={{ marginTop: '16px' }}>
          <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
            <Typography variant="h5" className={classes.title}>
              {title}
            </Typography>
            <Chip label={`${getPageTitle(contextPage)} #${contextOrder}`} color="accent" />
          </Box>
          <Paper className={classes.description} elevation={0}>
            <Typography variant="body1">{description}</Typography>
          </Paper>
        </Box>
      </Box>
      <Divider orientation="vertical" flexItem />
      <Box sx={{ flex: 20, height: '70%' }}>
        <Box sx={{ marginBottom: '16px' }}>
          <Typography variant="h6">Next Videos</Typography>
        </Box>
        <NextVideos />
      </Box>
    </Box>
  );
};
